export const buildListChannelName = (): string => `list`;
